import React, { useEffect, useState } from "react";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import dropdownArrow from "../../../images/gilead- collapse-dropdown.svg";
import DisabledBackArrowicon from "../../../images/gilead-disabled-dropdown-arrow.svg";
import "./selectAutocomplete.scss";
const SelectAutoComplete = (props) => {
  const {
    options,
    disableValue,
    label,
    required,
    renderOption,
    renderTag,
    onChange,
    value,
    disableClearable=true
  } = props;
  return (
    <Autocomplete
      //open={true}
      disableClearable={disableClearable}
      disablePortal
      id="combo-box-demo-selectbox"
      className={`autocomplete-select-custom ${
        disableValue ? "desabled-dropdown-css" : ""
      }`}
      popupIcon={
        <img
          src={options.length < 1 ? DisabledBackArrowicon : dropdownArrow}
          width={13}
          height={8}
          alt=""
        />
      }
      options={options}
      onChange={(e, newValue) => onChange(e, newValue, label)}
      value={value !== undefined ? value : null}
      getOptionLabel={(option) => option?.name || option || ""}
      isOptionEqualToValue={(option, value) =>
        option?._id === value?._id || option?.name === value?.name
      }
      disabled={disableValue}
      fullWidth={true}
      size="small"
      sx={{
        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
          fontSize: "12px",
          // transformOrigin: "top",
          color: "#66676b",
          borderColor: "none",
          outline: "none",
        },
        "& .MuiOutlinedInput-root": {
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#DDDFDD",
          },
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#DDDFDD",
            outline: "none",
            borderWidth: "1px",
          },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={
            <span>
              {label} {required ? <span className="required">*</span> : ""}
            </span>
          }
          placeholder="Search & Select"
          name={label}
          InputProps={{
            ...params.InputProps,
            //startAdornment: (label==="Modular Project ID" && value ?<img src={successIcon} style={{marginTop: '14px',height: '12px',width: '12px', marginLeft: '7px'}}/>:''),
          }}
        />
      )}
      renderOption={renderOption}

      //  renderTags={renderTag}
    />
  );
};

export default SelectAutoComplete;
